import { render } from "./StatSection.vue?vue&type=template&id=559c230a&scoped=true"
import script from "./StatSection.vue?vue&type=script&lang=js"
export * from "./StatSection.vue?vue&type=script&lang=js"

import "./StatSection.vue?vue&type=style&index=0&id=559c230a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-559c230a"]])

export default __exports__